import { render, staticRenderFns } from "./FinialGroup.vue?vue&type=template&id=3d0f45c8&scoped=true&"
import script from "./FinialGroup.vue?vue&type=script&lang=ts&"
export * from "./FinialGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FinialGroup.vue?vue&type=style&index=0&id=3d0f45c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f45c8",
  null
  
)

export default component.exports